var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('span',{staticClass:"card-wrapper"},[_c('span',{staticClass:"info-wrapper"},[_c('v-icon',{staticClass:"check-icon",attrs:{"size":"64","color":"rgb(40, 163, 63)"}},[_vm._v("mdi-lan-connect")]),_c('h1',{staticClass:"info-title",attrs:{"data-cy":"info"}},[_vm._v("Processando...")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }